<template>
  <div>
    <p class="backbutton"><a href="javascript:history.go(-1)">← Back</a></p>
    <b-container>
    <b-row>
      <b-col>
      <h3>{{ purifier.fullname }}</h3>
      <purifier-image :purifier="purifier"></purifier-image>
      <div class="shoplink">
      <a :href="purifier.webpage">Order Now →</a>
      </div>
    </b-col>
    <b-col>
    <div class="table-responsive purifierinfo">
      <table class="table">
        <tr>
          <td>Roomsize:</td>
          <td>{{ purifier.roomsize }} sqm</td>
        </tr>
        <tr>
          <td>CADR:</td>
          <td>{{ purifier.cadr }} cmb/hr</td>
        </tr>
        <tr>
          <td>HEPA lifespan:</td>
          <td>{{ purifier.hepaLifespan }} hours</td>
        </tr>
        <tr>
          <td>Weight:</td>
          <td>{{ purifier.weight }}kg</td>
        </tr>
        <tr>
          <td>Power:</td>
          <td>{{ purifier.power }}W</td>
        </tr>
      </table>
    </div>
  </b-col>
</b-row>
</b-container>
</div>
</template>

<script>
import {all} from '@/data/purifiers.js'
import PurifierImage from '@/components/PurifierImage'

export default {
  name: 'PurifierDetailView',
  components: {PurifierImage},
  props: ['id'],
  computed: {
    purifier: function () {
      var a = all.filter((i) => {
        return i.id === this.id
      })[0]
      console.log(a)
      return a
    }
  },
  created: function () {
    document.title = this.purifier.fullname + ' - Purifier Detailed Description'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
a h1, a h2, a:hover {
  text-decoration:none;
  color: #355197;
}
img.purifier_img {
  max-width:220px;
}
.backbutton {
  text-align:left;
  margin-bottom:0;
}
.purifierinfo {
  max-width:400px;
  margin: 0 auto;
}
.shoplink {
  margin: 30px 0;
  font-size:120%;
  font-weight:bold;
}
.table {
  margin-top:50px;
}
</style>



// WEBPACK FOOTER //
// src/components/PurifierDetailView.vue